module.exports = __webpack_public_path__ + "static/media/checked.24af96c2.svg";